<template>
  <div>
    <b-table
      striped
      hover
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(actions)="row">
        <b-button
          size="sm"
          @click="checkinClick(row.item)"
          class="mr-1"
          variant="primary"
        >
          Check In
        </b-button>

      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: { memberResult: Array },
  data() {
    return {
      fields: [
        "cardid",
        "firstname",
        "lastname",
        "nickname",
        "email",
        "phone",
        "actions"
      ],
      items: null,
      checkedMember: []
      //hasCheckedIn: false,
    };
  },
  computed: {},
  mounted() {
    this.items = this.memberResult;

    /*
    //console.log(this.memberResult);
    var resultArr = [];
    for (var i = 0; i < this.memberResult.length; i++) {
      let member = this.memberResult[i];
      let memberObj = {
        id: member.id,
        name: member.name,
        email: member.email,
        phone: member.phone,
      };
      resultArr.push(memberObj);
      //console.log(this.memberResult[i].email);
    }
    this.items = resultArr; */
  },
  methods: {
    checkinClick(item) {
      this.$emit("member-checkin", item);
    }
  }
};
</script>
